import { useTheme } from '@mui/material';

export const IntroIcon1 = ({ className }: { className: string }) => {
    const theme = useTheme();
    const {
        stroke: { primary: primaryStroke },
        background: { primary: primaryBackground },
    } = theme.colors.other.icon;

    return (
        <svg
            className={className}
            width="40"
            height="40"
            viewBox="0 0 40 40"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M8.8199 15.8339C8.92214 14.8115 9.78247 14.0329 10.81 14.0329H32.19C33.2175 14.0329 34.0779 14.8115 34.1801 15.8339L35.5602 29.6348C35.7957 31.9896 33.9465 34.0329 31.58 34.0329H11.4199C9.05346 34.0329 7.20433 31.9896 7.4398 29.6349L8.8199 15.8339Z"
                fill={primaryBackground}
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M22 7.46713H16C14.6193 7.46713 13.5 8.58642 13.5 9.96713V10.9428H24.5V9.96713C24.5 8.58642 23.3807 7.46713 22 7.46713ZM16 5.96713C13.7909 5.96713 12 7.75799 12 9.96713V10.9671H9.63713C7.5749 10.9671 5.85067 12.535 5.65515 14.5879L4.41706 27.5879C4.1934 29.9362 6.04007 31.9671 8.39904 31.9671H29.6009C31.9599 31.9671 33.8066 29.9362 33.5829 27.5879L32.3448 14.5879C32.1493 12.535 30.4251 10.9671 28.3628 10.9671H26V9.96713C26 7.75799 24.2091 5.96713 22 5.96713H16ZM28.3628 12.4671H9.63713C8.34824 12.4671 7.27059 13.447 7.14839 14.7301L5.9103 27.7301C5.77052 29.1978 6.92468 30.4671 8.39904 30.4671H29.6009C31.0753 30.4671 32.2295 29.1978 32.0897 27.7301L30.8516 14.7301C30.7294 13.447 29.6517 12.4671 28.3628 12.4671ZM18.5 15.7171C18.5 15.3029 18.8358 14.9671 19.25 14.9671C19.6642 14.9671 20 15.3029 20 15.7171V20.9671H24.75C25.1642 20.9671 25.5 21.3029 25.5 21.7171C25.5 22.1313 25.1642 22.4671 24.75 22.4671H20V27.2171C20 27.6313 19.6642 27.9671 19.25 27.9671C18.8358 27.9671 18.5 27.6313 18.5 27.2171V22.4671H13.25C12.8358 22.4671 12.5 22.1313 12.5 21.7171C12.5 21.3029 12.8358 20.9671 13.25 20.9671H18.5V15.7171Z"
                fill={primaryStroke}
            />
        </svg>
    );
};
